import { COLORS, Ic, ICONS, Wordmark } from "@/lib/theme";

/**
 * Desktop top navigation bar (>=900px).
 * On mobile the app uses the bottom TabBar instead.
 */
export default function NavBar({ tab, onSelect, user, isAdmin, onOpenAdmin, onLogout, onOpenAI }) {
  const tabs = [
    ["home", "Home", ICONS.home],
    ["times", "Times", ICONS.clock],
    ["give", "Give", ICONS.heart],
    ["community", "Community", ICONS.people],
    ["more", "More", ICONS.grid],
  ];
  return (
    <header
      data-testid="nav-bar"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 40,
        background: `linear-gradient(150deg, ${COLORS.purple}, ${COLORS.plum})`,
        color: "#fff",
        boxShadow: "0 4px 20px rgba(91,42,130,0.18)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1400,
          margin: "0 auto",
          padding: "16px 40px",
          display: "flex",
          alignItems: "center",
          gap: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 18, minWidth: 0 }}>
          <img
            src="/assets/linkshul-logo.png"
            alt="LinkShul"
            style={{ height: 60, borderRadius: 14, boxShadow: "0 6px 18px rgba(0,0,0,0.28)" }}
          />
          <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.15, minWidth: 0 }}>
            <span className="font-heading" style={{ fontWeight: 800, fontSize: 30, color: "#fff", letterSpacing: "-0.6px", lineHeight: 1 }}>
              <span>Link</span>
              <span style={{ color: COLORS.goldLight }}>shul</span>
            </span>
            <span style={{ color: "rgba(255,255,255,0.82)", fontSize: 13, fontWeight: 700, letterSpacing: 0.3, marginTop: 4, whiteSpace: "nowrap" }}>
              LinkShul
            </span>
          </div>
        </div>

        <nav style={{ display: "flex", gap: 4, flex: 1, justifyContent: "center" }}>
          {tabs.map(([k, label, d]) => {
            const on = tab === k;
            const isGive = k === "give";
            return (
              <button
                key={k}
                data-testid={`nav-${k}`}
                onClick={() => onSelect(k)}
                className="no-tap-highlight"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "9px 18px",
                  borderRadius: 24,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontFamily: "'Nunito', sans-serif",
                  fontSize: 14.5,
                  transition: "background 0.2s ease",
                  color: on ? COLORS.purple : "#fff",
                  background: on
                    ? "#fff"
                    : isGive
                    ? `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.goldLight})`
                    : "transparent",
                  boxShadow: on ? "0 4px 12px rgba(0,0,0,0.15)" : isGive ? "0 4px 12px rgba(201,162,75,0.4)" : "none",
                }}
                onMouseEnter={(e) => {
                  if (!on && !isGive) e.currentTarget.style.background = "rgba(255,255,255,0.14)";
                }}
                onMouseLeave={(e) => {
                  if (!on && !isGive) e.currentTarget.style.background = "transparent";
                }}
              >
                <Ic d={d} color={on ? COLORS.purple : isGive ? "#3a2a10" : "#fff"} size={18} w={2} />
                <span style={{ color: isGive && !on ? "#3a2a10" : undefined }}>{label}</span>
              </button>
            );
          })}
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button
            data-testid="nav-ai"
            onClick={onOpenAI}
            className="no-tap-highlight"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "9px 16px",
              borderRadius: 24,
              border: "1.5px solid rgba(255,255,255,0.35)",
              cursor: "pointer",
              background: "transparent",
              color: "#fff",
              fontWeight: 700,
              fontSize: 13.5,
              fontFamily: "'Nunito', sans-serif",
            }}
          >
            <Ic d={ICONS.chat} color="#fff" size={16} w={2} />
            Ask AI
          </button>
          {isAdmin && (
            <button
              data-testid="nav-admin"
              onClick={onOpenAdmin}
              className="no-tap-highlight"
              style={{
                padding: "9px 16px",
                borderRadius: 24,
                border: "none",
                cursor: "pointer",
                background: COLORS.gold,
                color: "#3a2a10",
                fontWeight: 800,
                fontSize: 13.5,
                fontFamily: "'Nunito', sans-serif",
              }}
            >
              Admin
            </button>
          )}
          {user && (
            <div
              title={`${user.first_name} ${user.last_name}`}
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: 800,
                fontSize: 15,
                fontFamily: "'Nunito', sans-serif",
              }}
            >
              {(user.first_name?.[0] || "").toUpperCase()}
              {(user.last_name?.[0] || "").toUpperCase()}
            </div>
          )}
          {user && (
            <button
              data-testid="nav-logout"
              onClick={onLogout}
              className="no-tap-highlight"
              title="Sign out"
              style={{
                background: "none",
                border: "none",
                color: "rgba(255,255,255,0.85)",
                cursor: "pointer",
                padding: 4,
              }}
            >
              <Ic d={ICONS.logout} color="#fff" size={22} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
